export default "__VITE_ASSET__CnQXz$9W__"